export class PhoneNumberApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getNumbers(params) {
    return this.#http.get('/phoneNumber', { params });
  }
}
